<template>
	<div class="contianer">
		<!-- 头部标题 -->
		<div class="header">
			<!-- <div class="header-retrun">&lt;</div>
			<div class="header-title">{{classes}}</div> -->
			<van-nav-bar left-text="返回" title="收藏" left-arrow @click-left="onClickLeft()"/>
		</div>
		<!-- 间距 -->
		<div class="margin20"></div>
		<!-- 中部收藏数量显示 -->
		<div class="collect-box">
			<img src='../../assets/user/record.png'/>
			<p><span>124</span>题</p>
			<div class="seeBtn">查看收藏</div>
		</div>
		<!-- 间距 -->
		<div class="margin20"></div>
		<!-- 底部内容显示 -->
		<div class="bottom">
			<div class="bottom-text">今日收藏： 12</div>
			<div class="bottom-btn">开始练习</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"CollectBank",
		data() {
			return {
				
			}
		},
		methods: {
			onClickLeft() {
				this.$router.go(-1)
			}
		},
	}
</script>

<style>
	.contianer{
		width: 100%;
		min-height: 100vh;
		background: #fff;
	}
	/* 头部 */
	.header{
		width: 100%;
		position: relative;
		font-size: 0.875rem;
	}
	.header-title{
		text-align: center;
		line-height: 2.5rem;
	}
	.header-retrun{
		height: 2.5rem;
		line-height: 2.5rem;
		position: absolute;
		top: 0;
		left: 0.625rem;
		
	}
	/* 间距 */
	.margin20{
		width: 100%;
		height: 0.3125rem;
		background: #F5F4F9;
	}
	/* 内容区 */
	.collect-box{
		width: 100%;
		height: 12.5rem;
		position: relative;
	}

	.collect-box img{
		width: 10rem;
		height: 7.5rem;
		position: absolute;
		left: 50%;
		margin-left: -5rem;
		top: 1.5rem;
	}
	.collect-box p{
		font-weight: bold;
		font-size: 3vw;
		color: #000;
		position: absolute;
		left: 50%;
		margin-left: -6.5vw;
		top:5rem;
		color: #fff;
	}
	.collect-box p span{
		font-size: 6.5vw;
	}
	/* 查看收藏按钮 */
	.seeBtn{
		width:6rem;
		height:1.7rem;
		color: #fff;
		font-size: 0.9rem;
		background: #FCA492;
		border-radius: 0.75rem;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 9.3rem;
		left: 50%;
		margin-left: -3rem;
		font-weight: bold;
		letter-spacing: 2px;
	}
	/* 底部内容显示 */
	.bottom{
		margin-top: 1rem;
		color: #333;
		font-weight: bold;
		width: 90%;
		margin: 1.5rem auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.bottom-text{
		font-size: 3vw;
	}
	.bottom-btn{
		font-size: 4vw;
		width: 6rem;
		height: 1.7rem;
		border-radius: 0.75rem;
		border: 1px solid #FCA492;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>



// WEBPACK FOOTER //
// src/pages/user/CollectBank.vue